import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { storeResources } from '../resources';
import { ThunkGetUserData } from './thunks';
import { IUserData } from 'services/user/types';
import { Roles } from 'constants/roles';
import { RootState } from 'store/types';

interface IInitialState {
  userData: IUserData;
  role: Roles | undefined;
}

const initialState: IInitialState = {
  userData: {
    companyName: '',
    contactEmail: '',
    contactName: '',
    contactPhone: '',
    googleLinked: false,
    microsoftLinked: false,
    useCustomTicketStatusFilter: true,
    customFilterTicketStatuses: [],
  },
  role: undefined,
};

const userSlice = createSlice({
  name: storeResources.AUTH,
  initialState,
  reducers: {
    changeLinkState: (
      state,
      action: PayloadAction<{ type: 'Microsoft' | 'Google'; state: boolean }>,
    ) => {
      if (action.payload.type === 'Microsoft') {
        state.userData = { ...state.userData, microsoftLinked: action.payload.state };
      }
      if (action.payload.type === 'Google') {
        state.userData = { ...state.userData, googleLinked: action.payload.state };
      }
    },
    setUserRole: (state, action: PayloadAction<Roles>) => {
      state.role = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(ThunkGetUserData.fulfilled, (state, action) => {
      state.userData = action.payload;
    });
  },
});

export default userSlice.reducer;

export const { changeLinkState, setUserRole } = userSlice.actions;

export const UserDataSelector = (state: RootState): IUserData => state.user.userData;
